import { Component, createEffect, createSignal, Show } from "solid-js";

type Props = {
    when?: () => boolean;
}
export const Required : Component<Props> = (props) => {
    const [visible, setVisible] = createSignal<boolean>(true);
    createEffect(() => {
        if (props?.when) {
            setVisible(typeof props.when === "undefined" || props?.when());
        }
    });
    return (
        <>
            <Show when={visible()}>
                <span style="color: red;" class="fa fa-star"></span>
            </Show>
        </>
    );
}